module.exports = __webpack_public_path__ + "img/header_dsk@2x.03f1afc.jpg";